import { render, staticRenderFns } from "./WidgetsDropdown.vue?vue&type=template&id=b49450d2&scoped=true"
import script from "./WidgetsDropdown.vue?vue&type=script&lang=js"
export * from "./WidgetsDropdown.vue?vue&type=script&lang=js"
import style0 from "./WidgetsDropdown.vue?vue&type=style&index=0&id=b49450d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49450d2",
  null
  
)

export default component.exports